import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
export const RulePinOutOfStockOnIcon = (props) => (<SvgIcon viewBox="0 0 16 16" {...props}>
    <path d="M13.3334 4L6.00008 11.3333L2.66675 8" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>);
export default RulePinOutOfStockOnIcon;
